<template>
  <span></span>
</template>

<script>
import ProcessScheduleModel from "@/models/lab/ProcessScheduleModel";
import moment from "moment";

export default {
  name: "ScheduleProcessDownload",

  props: {
    process_schedule: {
      type: ProcessScheduleModel,
      default: () => null
    }
  },

  methods: {
    download() {
      return this.process_schedule.downloadList().then(({ response }) => {
        const items = response.data.data;
        const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here
        const header = Object.keys(items[0]);
        let csv = items.map(row =>
          header
            .map(fieldName => JSON.stringify(row[fieldName], replacer))
            .join(",")
        );
        csv.unshift(header.join(","));
        csv = csv.join("\r\n");
        let hiddenElement = document.createElement("a");
        hiddenElement.href =
          "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        hiddenElement.target = "_blank";
        hiddenElement.download =
          moment().format("YYYYMMDDHHmmss_") + "schedule.csv";
        hiddenElement.click();
      });
    }
  }
};
</script>
